import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { ApiEnvelope } from './super-admin-auth.service';

/**
 * Effective permissions for the signed-in super-admin user (`GET /permission/user`).
 * `data` is a map of module key → permission rows (each includes `slug`).
 */
@Injectable({ providedIn: 'root' })
export class UserPermissionApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');

  fetchUserPermissionsGrouped(): Observable<ApiEnvelope<Record<string, unknown[]>>> {
    return this.http.get<ApiEnvelope<Record<string, unknown[]>>>(
      `${this.base}/permission/user`,
    );
  }
}
